<template>
	<span
		style="width: 20%"
	>
		<span v-if="taxPayer.id">
			<span :class="{'set-click': clickable && isAdminLogin && entityId}" @click="gotoProfile">{{ taxPayer.reg_no }}</span> 
			<span v-if="requireName">({{getFullName()}})</span>
		</span>
		<span v-else>-</span>
	</span>
</template>

<script>
import { profileFullName, isAdmin } from "@/lib/utils";

export default {
	name: 'tax-payer-id',

	data() {
		return {
			isAdminLogin: isAdmin()
		}
	},

	props: {
		taxPayer: {
			type: Object,
			default: () => {}
		},
		requireName: {
			type: Boolean,
			default: false
		},
		clickable: {
			type: Boolean,
			default: true
		}
	},

	computed: {
		taxPayerType() {
			return this.taxPayer.entity_type_id == this.$constants.individualEntityTypeId ? 'individual' : 'corporate';
		},

		entityId() {
			return this.taxPayer.entity_id;
		}
	},

	methods: {
		gotoProfile() {
			if(!this.clickable || !this.isAdminLogin || !this.entityId) return;

			this.$router.push(`/tax-payers/${this.taxPayerType}/${this.taxPayer.entity_id}`);
		},

		getFullName() {
			const payerEntity = this.taxPayer.entity || this.taxPayer;
      return profileFullName(payerEntity);
    }
	}
}
</script>
<style scoped>
.set-click {
	cursor: pointer;
  text-decoration: underline;
}
</style>
